export const DASHBOARD_CARDS_VALUE = 'DASHBOARD_CARDS_VALUE';
export const LOAD_DASHBOARD_CARDS = 'LOAD_DASHBOARD_CARDS';


// WEBPACK FOOTER //
// ./src/ZWallet/Dashboard/types.js